/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};

export enum AreaEnum {
  Ch = 'CH',
  Cn = 'CN',
  Lc = 'LC',
  Mt = 'MT',
}

export type BaseIndicatorEventDayInput = {
  /** the day of the exam */
  day: Scalars['Int'];
  /** the end date of the exam */
  endAt: Scalars['DateTime'];
  /** the name of the exam */
  examName: Scalars['String'];
  /** the number of exam questions */
  numberOfQuestions: Scalars['Int'];
  /** the start date of the exam */
  startAt: Scalars['DateTime'];
};

export enum ChartTypeEnum {
  Distribution = 'distribution',
  Likert = 'likert',
  LikertDistribution = 'likertDistribution',
  Scatter = 'scatter',
}

export type ChartTypeObject = {
  __typename?: 'ChartTypeObject';
  BRANDS?: Maybe<ChartTypeEnum>;
  GENERAL?: Maybe<ChartTypeEnum>;
  SCHOOLS?: Maybe<ChartTypeEnum>;
};

export type CreateIndicatorEventInput = {
  /** the days of the exam */
  days: Array<BaseIndicatorEventDayInput>;
  /** the description of the event */
  description: Scalars['String'];
  /** the name of the event */
  name: Scalars['String'];
  /** the number of days of the event */
  numberOfDays: Scalars['Int'];
  /** the number of schools participating in the event */
  participatingSchools: Scalars['Int'];
  /** the number of students participating in the event */
  participatingStudents: Scalars['Int'];
  /** the year of the event */
  year: Scalars['String'];
};

export type EntityData = {
  __typename?: 'EntityData';
  consistency: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  participatingSchools?: Maybe<Scalars['Float']>;
  participatingStudents: Scalars['Float'];
  type: Scalars['String'];
};

export type EntityFilterType = {
  __typename?: 'EntityFilterType';
  filterType?: Maybe<FilterTypeEnum>;
  id: Scalars['String'];
  label: Scalars['String'];
};

export type EnvironmentWithIndicators = {
  __typename?: 'EnvironmentWithIndicators';
  id: Scalars['String'];
  indicators: Array<IndicatorChart>;
  name: Scalars['String'];
  order: Scalars['Float'];
};

export type FilterType = {
  __typename?: 'FilterType';
  id: Scalars['String'];
  label: Scalars['String'];
};

export enum FilterTypeEnum {
  Brands = 'BRANDS',
  General = 'GENERAL',
  Schools = 'SCHOOLS',
}

export type Indicator = {
  __typename?: 'Indicator';
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  scale: Scalars['Float'];
  slug: Scalars['String'];
};

export type IndicatorByContext = {
  __typename?: 'IndicatorByContext';
  context: Scalars['String'];
  environments: Array<EnvironmentWithIndicators>;
};

export type IndicatorChart = {
  __typename?: 'IndicatorChart';
  chartType: ChartTypeObject;
  description: Scalars['String'];
  filters: IndicatorFilters;
  id: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Int'];
  scale: Scalars['Int'];
};

export type IndicatorEvent = {
  __typename?: 'IndicatorEvent';
  days: Array<IndicatorEventDay>;
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  numberOfDays: Scalars['Float'];
  participatingSchools: Scalars['Float'];
  participatingStudents: Scalars['Float'];
  year: Scalars['String'];
};

export type IndicatorEventDay = {
  __typename?: 'IndicatorEventDay';
  day: Scalars['Float'];
  endAt: Scalars['DateTime'];
  examName: Scalars['String'];
  numberOfQuestions: Scalars['Float'];
  startAt: Scalars['DateTime'];
};

export type IndicatorFilters = {
  __typename?: 'IndicatorFilters';
  area?: Maybe<Array<FilterType>>;
  chartsFilters?: Maybe<Array<FilterType>>;
  columns?: Maybe<Array<FilterType>>;
  entity?: Maybe<Array<EntityFilterType>>;
  hasSimilarSchools?: Maybe<Scalars['Boolean']>;
};

export type IndicatorResult = {
  __typename?: 'IndicatorResult';
  elementarySchool1: Segment;
  elementarySchool2: Segment;
  entityName?: Maybe<Scalars['String']>;
  general: Segment;
  highSchool: Segment;
  school?: Maybe<SchoolObject>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** create an event of indicators */
  createIndicatorEvent: IndicatorEvent;
  /** update an event of indicators */
  updateIndicatorEvent: IndicatorEvent;
};

export type MutationCreateIndicatorEventArgs = {
  indicatorEventInput: CreateIndicatorEventInput;
};

export type MutationUpdateIndicatorEventArgs = {
  id: Scalars['String'];
  indicatorEventInput: UpdateIndicatorEventInput;
};

export type PaginatedIndicatorResult = {
  __typename?: 'PaginatedIndicatorResult';
  _pagination: PaginationReturn;
  data: Array<IndicatorResult>;
};

export type PaginatedUserBrandEntity = {
  __typename?: 'PaginatedUserBrandEntity';
  _pagination: PaginationReturn;
  data: Array<UserBrandEntity>;
};

export type PaginatedUserSchoolEntity = {
  __typename?: 'PaginatedUserSchoolEntity';
  _pagination: PaginationReturn;
  data: Array<UserSchoolEntity>;
};

export type PaginationReturn = {
  __typename?: 'PaginationReturn';
  currentPage: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export type Points = {
  __typename?: 'Points';
  label: Scalars['String'];
  points: Array<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  entityData?: Maybe<EntityData>;
  indicator: Indicator;
  indicatorByContext: IndicatorByContext;
  indicatorEvent?: Maybe<IndicatorEvent>;
  indicatorEvents: Array<IndicatorEvent>;
  indicatorResult: PaginatedIndicatorResult;
  schoolEffectResultByBrand: SchoolEffectResult;
  schoolEffectResultByCompany: SchoolEffectResult;
  schoolEffectResultBySchool: SchoolEffectResult;
  userBrandEntities: PaginatedUserBrandEntity;
  userSchoolEntities: PaginatedUserSchoolEntity;
};

export type QueryEntityDataArgs = {
  externalId: Scalars['String'];
  indicatorEventId: Scalars['String'];
};

export type QueryIndicatorArgs = {
  id: Scalars['String'];
};

export type QueryIndicatorByContextArgs = {
  context: Scalars['String'];
  indicatorEventId: Scalars['String'];
};

export type QueryIndicatorEventArgs = {
  id: Scalars['String'];
};

export type QueryIndicatorResultArgs = {
  entityId: Scalars['String'];
  entityNameFilter?: Maybe<Scalars['String']>;
  filterType?: Maybe<FilterTypeEnum>;
  indicatorEventId: Scalars['String'];
  indicatorId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
};

export type QuerySchoolEffectResultByBrandArgs = {
  area: AreaEnum;
  id: Scalars['String'];
  indicatorEventId: Scalars['String'];
  segment: SegmentEnum;
};

export type QuerySchoolEffectResultByCompanyArgs = {
  area: AreaEnum;
  indicatorEventId: Scalars['String'];
  segment: SegmentEnum;
};

export type QuerySchoolEffectResultBySchoolArgs = {
  area: AreaEnum;
  id: Scalars['String'];
  indicatorEventId: Scalars['String'];
  segment: SegmentEnum;
};

export type QueryUserBrandEntitiesArgs = {
  indicatorEventId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
};

export type QueryUserSchoolEntitiesArgs = {
  indicatorEventId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
};

export type SchoolEffectResult = {
  __typename?: 'SchoolEffectResult';
  expectedProficiencyLine: Array<Array<Scalars['Float']>>;
  highlightPoints: Array<Points>;
  regularPoints?: Maybe<Array<Array<Scalars['Int']>>>;
};

export type SchoolObject = {
  __typename?: 'SchoolObject';
  brandsName: Scalars['String'];
  name: Scalars['String'];
};

export type Segment = {
  __typename?: 'Segment';
  distribution?: Maybe<Array<Scalars['Float']>>;
  scaleValue?: Maybe<Scalars['Float']>;
  similarDistribution?: Maybe<Array<Scalars['Float']>>;
  similarScaleValue?: Maybe<Scalars['Float']>;
};

export enum SegmentEnum {
  EfI = 'EF_I',
  EfIi = 'EF_II',
  Em = 'EM',
}

export type UpdateIndicatorEventInput = {
  /** the days of the exam */
  days?: Maybe<Array<BaseIndicatorEventDayInput>>;
  /** the description of the event */
  description?: Maybe<Scalars['String']>;
  /** the name of the event */
  name?: Maybe<Scalars['String']>;
  /** the number of days of the event */
  numberOfDays?: Maybe<Scalars['Int']>;
  /** the number of schools participating in the event */
  participatingSchools?: Maybe<Scalars['Int']>;
  /** the number of students participating in the event */
  participatingStudents?: Maybe<Scalars['Int']>;
  /** the year of the event */
  year?: Maybe<Scalars['String']>;
};

export type UserBrandEntity = {
  __typename?: 'UserBrandEntity';
  consistency: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type UserSchoolEntity = {
  __typename?: 'UserSchoolEntity';
  brandNames: Array<Scalars['String']>;
  consistency?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type GetPaginatedSchoolsQueryVariables = Exact<{
  limit: Scalars['Int'];
  page: Scalars['Int'];
  searchName?: Maybe<Scalars['String']>;
  indicatorEventId: Scalars['String'];
}>;

export type GetPaginatedSchoolsQuery = {
  __typename?: 'Query';
  schools: {
    __typename?: 'PaginatedUserSchoolEntity';
    _pagination: {
      __typename?: 'PaginationReturn';
      hasNextPage: boolean;
      totalPage: number;
      currentPage: number;
      totalCount: number;
    };
    data: Array<{
      __typename?: 'UserSchoolEntity';
      id: string;
      name: string;
      brandNames: Array<string>;
    }>;
  };
};

export type UpdateIndicatorsByContextQueryVariables = Exact<{
  context: Scalars['String'];
  indicatorEventId: Scalars['String'];
}>;

export type UpdateIndicatorsByContextQuery = {
  __typename?: 'Query';
  indicatorsByContext: {
    __typename?: 'IndicatorByContext';
    data: Array<{
      __typename?: 'EnvironmentWithIndicators';
      id: string;
      order: number;
      name: string;
      indicators: Array<{
        __typename?: 'IndicatorChart';
        id: string;
        name: string;
        description: string;
        order: number;
        scale: number;
        filters: {
          __typename?: 'IndicatorFilters';
          hasSimilarSchools?: Maybe<boolean>;
          columns?: Maybe<
            Array<{ __typename?: 'FilterType'; id: string; label: string }>
          >;
          entity?: Maybe<
            Array<{
              __typename?: 'EntityFilterType';
              id: string;
              label: string;
            }>
          >;
          area?: Maybe<
            Array<{ __typename?: 'FilterType'; id: string; label: string }>
          >;
          chartsFilters?: Maybe<
            Array<{ __typename?: 'FilterType'; id: string; label: string }>
          >;
        };
        chartType: {
          __typename?: 'ChartTypeObject';
          GENERAL?: Maybe<ChartTypeEnum>;
          BRANDS?: Maybe<ChartTypeEnum>;
          SCHOOLS?: Maybe<ChartTypeEnum>;
        };
      }>;
    }>;
  };
};

export type GetInitialAppDataQueryVariables = Exact<{
  entityId: Scalars['String'];
  context: Scalars['String'];
  indicatorEventId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
}>;

export type GetInitialAppDataQuery = {
  __typename?: 'Query';
  currentEntity?: Maybe<{
    __typename?: 'EntityData';
    id: string;
    type: string;
    name: string;
    participatingSchools?: Maybe<number>;
    participatingStudents: number;
    consistency: boolean;
  }>;
  hasCompanyPermission?: Maybe<{
    __typename?: 'EntityData';
    id: string;
    type: string;
    name: string;
    participatingSchools?: Maybe<number>;
    participatingStudents: number;
    consistency: boolean;
  }>;
  indicatorEvent?: Maybe<{
    __typename?: 'IndicatorEvent';
    id: string;
    name: string;
    year: string;
    participatingSchools: number;
    participatingStudents: number;
    description: string;
    numberOfDays: number;
    days: Array<{
      __typename?: 'IndicatorEventDay';
      day: number;
      examName: string;
      numberOfQuestions: number;
      startAt: any;
      endAt: any;
    }>;
  }>;
  brands: {
    __typename?: 'PaginatedUserBrandEntity';
    _pagination: {
      __typename?: 'PaginationReturn';
      hasNextPage: boolean;
      totalPage: number;
      currentPage: number;
      totalCount: number;
    };
    data: Array<{ __typename?: 'UserBrandEntity'; id: string; name: string }>;
  };
  schools: {
    __typename?: 'PaginatedUserSchoolEntity';
    _pagination: {
      __typename?: 'PaginationReturn';
      hasNextPage: boolean;
      totalPage: number;
      currentPage: number;
      totalCount: number;
    };
    data: Array<{
      __typename?: 'UserSchoolEntity';
      id: string;
      name: string;
      brandNames: Array<string>;
    }>;
  };
  indicatorsByContext: {
    __typename?: 'IndicatorByContext';
    data: Array<{
      __typename?: 'EnvironmentWithIndicators';
      id: string;
      order: number;
      name: string;
      indicators: Array<{
        __typename?: 'IndicatorChart';
        id: string;
        name: string;
        description: string;
        order: number;
        scale: number;
        filters: {
          __typename?: 'IndicatorFilters';
          hasSimilarSchools?: Maybe<boolean>;
          columns?: Maybe<
            Array<{ __typename?: 'FilterType'; id: string; label: string }>
          >;
          entity?: Maybe<
            Array<{
              __typename?: 'EntityFilterType';
              id: string;
              label: string;
            }>
          >;
          area?: Maybe<
            Array<{ __typename?: 'FilterType'; id: string; label: string }>
          >;
          chartsFilters?: Maybe<
            Array<{ __typename?: 'FilterType'; id: string; label: string }>
          >;
        };
        chartType: {
          __typename?: 'ChartTypeObject';
          GENERAL?: Maybe<ChartTypeEnum>;
          BRANDS?: Maybe<ChartTypeEnum>;
          SCHOOLS?: Maybe<ChartTypeEnum>;
        };
      }>;
    }>;
  };
};

export const GetPaginatedSchoolsDocument = gql`
  query getPaginatedSchools(
    $limit: Int!
    $page: Int!
    $searchName: String
    $indicatorEventId: String!
  ) {
    schools: userSchoolEntities(
      limit: $limit
      name: $searchName
      page: $page
      indicatorEventId: $indicatorEventId
    ) {
      _pagination {
        hasNextPage
        totalPage
        currentPage
        totalCount
      }
      data {
        id
        name
        brandNames
      }
    }
  }
`;

/**
 * __useGetPaginatedSchoolsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedSchoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedSchoolsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      searchName: // value for 'searchName'
 *      indicatorEventId: // value for 'indicatorEventId'
 *   },
 * });
 */
export function useGetPaginatedSchoolsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPaginatedSchoolsQuery,
    GetPaginatedSchoolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPaginatedSchoolsQuery,
    GetPaginatedSchoolsQueryVariables
  >(GetPaginatedSchoolsDocument, options);
}
export function useGetPaginatedSchoolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPaginatedSchoolsQuery,
    GetPaginatedSchoolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPaginatedSchoolsQuery,
    GetPaginatedSchoolsQueryVariables
  >(GetPaginatedSchoolsDocument, options);
}
export type GetPaginatedSchoolsQueryHookResult = ReturnType<
  typeof useGetPaginatedSchoolsQuery
>;
export type GetPaginatedSchoolsLazyQueryHookResult = ReturnType<
  typeof useGetPaginatedSchoolsLazyQuery
>;
export type GetPaginatedSchoolsQueryResult = Apollo.QueryResult<
  GetPaginatedSchoolsQuery,
  GetPaginatedSchoolsQueryVariables
>;
export const UpdateIndicatorsByContextDocument = gql`
  query updateIndicatorsByContext(
    $context: String!
    $indicatorEventId: String!
  ) {
    indicatorsByContext: indicatorByContext(
      context: $context
      indicatorEventId: $indicatorEventId
    ) {
      data: environments {
        id
        order
        name
        indicators {
          id
          name
          description
          order
          scale
          filters {
            hasSimilarSchools
            columns {
              id
              label
            }
            entity {
              id
              label
            }
            area {
              id
              label
            }
            chartsFilters {
              id
              label
            }
          }
          chartType {
            GENERAL
            BRANDS
            SCHOOLS
          }
        }
      }
    }
  }
`;

/**
 * __useUpdateIndicatorsByContextQuery__
 *
 * To run a query within a React component, call `useUpdateIndicatorsByContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndicatorsByContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateIndicatorsByContextQuery({
 *   variables: {
 *      context: // value for 'context'
 *      indicatorEventId: // value for 'indicatorEventId'
 *   },
 * });
 */
export function useUpdateIndicatorsByContextQuery(
  baseOptions: Apollo.QueryHookOptions<
    UpdateIndicatorsByContextQuery,
    UpdateIndicatorsByContextQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UpdateIndicatorsByContextQuery,
    UpdateIndicatorsByContextQueryVariables
  >(UpdateIndicatorsByContextDocument, options);
}
export function useUpdateIndicatorsByContextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UpdateIndicatorsByContextQuery,
    UpdateIndicatorsByContextQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UpdateIndicatorsByContextQuery,
    UpdateIndicatorsByContextQueryVariables
  >(UpdateIndicatorsByContextDocument, options);
}
export type UpdateIndicatorsByContextQueryHookResult = ReturnType<
  typeof useUpdateIndicatorsByContextQuery
>;
export type UpdateIndicatorsByContextLazyQueryHookResult = ReturnType<
  typeof useUpdateIndicatorsByContextLazyQuery
>;
export type UpdateIndicatorsByContextQueryResult = Apollo.QueryResult<
  UpdateIndicatorsByContextQuery,
  UpdateIndicatorsByContextQueryVariables
>;
export const GetInitialAppDataDocument = gql`
  query getInitialAppData(
    $entityId: String!
    $context: String!
    $indicatorEventId: String!
    $limit: Int = 10
  ) {
    currentEntity: entityData(
      externalId: $entityId
      indicatorEventId: $indicatorEventId
    ) {
      id
      type
      name
      participatingSchools
      participatingStudents
      consistency
    }
    hasCompanyPermission: entityData(
      externalId: "SOMOS"
      indicatorEventId: $indicatorEventId
    ) {
      id
      type
      name
      participatingSchools
      participatingStudents
      consistency
    }
    indicatorEvent(id: $indicatorEventId) {
      id
      name
      year
      participatingSchools
      participatingStudents
      description
      numberOfDays
      days {
        day
        examName
        numberOfQuestions
        startAt
        endAt
      }
    }
    brands: userBrandEntities(
      page: 1
      limit: 1000
      indicatorEventId: $indicatorEventId
    ) {
      _pagination {
        hasNextPage
        totalPage
        currentPage
        totalCount
      }
      data {
        id
        name
      }
    }
    schools: userSchoolEntities(
      page: 1
      limit: $limit
      indicatorEventId: $indicatorEventId
    ) {
      _pagination {
        hasNextPage
        totalPage
        currentPage
        totalCount
      }
      data {
        id
        name
        brandNames
      }
    }
    indicatorsByContext: indicatorByContext(
      context: $context
      indicatorEventId: $indicatorEventId
    ) {
      data: environments {
        id
        order
        name
        indicators {
          id
          name
          description
          order
          scale
          filters {
            hasSimilarSchools
            columns {
              id
              label
            }
            entity {
              id
              label
            }
            area {
              id
              label
            }
            chartsFilters {
              id
              label
            }
          }
          chartType {
            GENERAL
            BRANDS
            SCHOOLS
          }
        }
      }
    }
  }
`;

/**
 * __useGetInitialAppDataQuery__
 *
 * To run a query within a React component, call `useGetInitialAppDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitialAppDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitialAppDataQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      context: // value for 'context'
 *      indicatorEventId: // value for 'indicatorEventId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetInitialAppDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInitialAppDataQuery,
    GetInitialAppDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetInitialAppDataQuery,
    GetInitialAppDataQueryVariables
  >(GetInitialAppDataDocument, options);
}
export function useGetInitialAppDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInitialAppDataQuery,
    GetInitialAppDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetInitialAppDataQuery,
    GetInitialAppDataQueryVariables
  >(GetInitialAppDataDocument, options);
}
export type GetInitialAppDataQueryHookResult = ReturnType<
  typeof useGetInitialAppDataQuery
>;
export type GetInitialAppDataLazyQueryHookResult = ReturnType<
  typeof useGetInitialAppDataLazyQuery
>;
export type GetInitialAppDataQueryResult = Apollo.QueryResult<
  GetInitialAppDataQuery,
  GetInitialAppDataQueryVariables
>;
